import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const catalogService = { getAll, store, show, update, updateStatus, softDelete };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy
    };
    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) {
        params.search_words = searchWords;
    }
    return apiHelper(API_URL).get('/catalogs', { params });
}

function toFormData(data, method = null) {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('catalog_subcategory_uuid', data.catalogSubcategoryUUID);
    formData.append('company_uuid', data.companyUUID);
    formData.append('description', data.description);
    formData.append('pic_user_uuid', data.picUserUUID);
    if (data.pdf instanceof File) formData.append('pdf', data.pdf);
    if (method) formData.append('_method', method);
    return formData;
}

export function store(data) {
    return apiHelper(API_URL).post('/catalogs', toFormData(data));
}
export function show(uuid) {
    return apiHelper(API_URL).get(`/catalogs/${uuid}`);
}
export function update(data) {
    return apiHelper(API_URL).post(`/catalogs/${data.uuid}`, toFormData(data, 'PUT'));
}
export function updateStatus(uuid, isActive) {
    return apiHelper(API_URL).patch(`/catalogs/${uuid}`, { is_active: isActive ? 1 : 0 });
}
export function softDelete(uuid) {
    return apiHelper(API_URL).patch(`/catalogs/delete/${uuid}`);
}
